import { Text } from '@abyss/web/ui/Text';
import { useTranslation } from 'react-i18next';

import { CostIndicators } from '../Constants';
import {
  AboveAverageTextColor,
  AverageTextColor,
  BelowAverageTextColor,
  DefaultTextColor,
  TextCostIndicator,
} from './CostIndicator.styles';

type Props = {
  indicatorData: string;
  enableMapViewHideOption?: boolean;
  isGroupedLocationDrawer?: boolean;
};

export const CostIndicator = ({
  indicatorData,
  enableMapViewHideOption = false,
  isGroupedLocationDrawer,
}: Props) => {
  const { t } = useTranslation();
  const getCostRateIndacators = (costIndicator: string) => {
    switch (costIndicator) {
      case CostIndicators.$:
        // First '$' in green ramaining '$' in gray color
        return (
          <div data-testid="cost-rate-indicator">
            <TextCostIndicator
              css={BelowAverageTextColor}
              data-testid="below-average-indicator"
            >
              $
            </TextCostIndicator>
            <TextCostIndicator
              css={DefaultTextColor}
              data-testid="default-average-indicator"
            >
              $$
            </TextCostIndicator>
            {enableMapViewHideOption && (
              <Text
                css={{
                  color: '$success1', // Hex: #007000 green
                  marginLeft: '4px',
                }}
                data-testid="below-average-cost-text"
              >
                {t('Below average cost')}
              </Text>
            )}
          </div>
        );

      case CostIndicators.$$:
        // First and Second '$$' in blue ramaining '$' in gray color
        return (
          <div data-testid="cost-rate-indicator">
            <TextCostIndicator
              css={AverageTextColor}
              data-testid="average-indicator"
            >
              $$
            </TextCostIndicator>
            <TextCostIndicator
              css={DefaultTextColor}
              data-testid="default-average-indicator"
            >
              $
            </TextCostIndicator>
            {enableMapViewHideOption && (
              <Text
                css={{
                  color: '#0248AC', // Blue
                  marginLeft: '4px',
                }}
                data-testid="average-cost-text"
              >
                {t('Average cost')}
              </Text>
            )}
          </div>
        );

      case CostIndicators.$$$:
        // All the '$' in red color
        return (
          <div data-testid="cost-rate-indicator">
            <TextCostIndicator
              css={AboveAverageTextColor}
              data-testid="above-average-indicator"
            >
              $$$
            </TextCostIndicator>
            {enableMapViewHideOption && (
              <Text
                css={{
                  color: '#AA2E23', // red
                  marginLeft: '4px',
                }}
                data-testid="above-average-cost-text"
              >
                {t('Above average cost')}
              </Text>
            )}
          </div>
        );

      default:
        // All the '$' in gray color
        return (
          <div data-testid="cost-rate-indicator">
            <TextCostIndicator
              css={DefaultTextColor}
              cssProps={{ isGroupedLocationDrawer, costUnavailable: true }}
              data-testid="default-average-indicator"
            >
              {!enableMapViewHideOption || (isGroupedLocationDrawer && '$$$')}
            </TextCostIndicator>
            {enableMapViewHideOption && (
              <Text
                css={{
                  color: isGroupedLocationDrawer ? '$gray7' : '$gray5',
                  marginLeft: '4px',
                }}
                data-testid="default-cost-text"
              >
                {t('Cost unavailable')}
              </Text>
            )}
          </div>
        );
    }
  };

  return getCostRateIndacators(indicatorData);
};
